module.exports = __webpack_public_path__ + "static/media/ie.bae8083c.svg";